import { object } from "../helpers/object";
import { debug } from "../helpers/debug";

/*------------------------------------*\
  #SWITCH

  Gestion des switchs

\*------------------------------------*/
class Switch {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    
    if(debug.DEBUG) console.log('components/switch.js');
  };

  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-component="switch"]')) {
      this.labelsStateHandler(event.target);
    }
  }
  
  labelsStateHandler = (element) => {
    const input = element.querySelector('input');
    const labelOff = element.querySelector('[data-js-switch-label="off"]');
    const labelOn = element.querySelector('[data-js-switch-label="on"]');
    const isChecked = !input.checked;

    if (labelOff) labelOff.setAttribute('aria-current', !isChecked);
    if (labelOn) labelOn.setAttribute('aria-current', isChecked);

  }
}
export const switchs = new Switch('[data-js-component="switch"]'); 